/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface Consent { 
    consentFormUrl: string;
    privacyPolicyUrl: string;
}
export const Consent_consentFormUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const Consent_privacyPolicyUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];


